"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyMetersFromContracts = exports.getTimingCategoriesFromContracts = void 0;
var date_fns_1 = require("date-fns");
var constants_1 = require("../../constants");
var utils_1 = require("../../utils");
var dummyOpeningRegister = {
    registerId: '0',
    timeOfUseLabel: 'anytime',
    startDate: constants_1.BACKUP_STARTDATE,
    endDate: null,
};
var dummyOpeningMeterInfo = {
    msn: constants_1.DUMMY_MSN,
    meterNumOfDigits: undefined,
    rawMeterType: constants_1.UNIVERSAL_TRAD_METER_TYPE,
    registers: [dummyOpeningRegister],
    meterStatus: 'active',
};
var getTimingCategoriesFromContracts = function (contractsTariffData, sprn, accountSupplyPointStartDate) {
    var contractsForSupply = contractsTariffData === null || contractsTariffData === void 0 ? void 0 : contractsTariffData.account.contracts_nextV1.edges.filter(function (contract) { return contract.node.supplyPoint.sprn === sprn; });
    var contractForAsp = contractsForSupply === null || contractsForSupply === void 0 ? void 0 : contractsForSupply.find(function (contract) {
        return (0, date_fns_1.isEqual)(new Date(contract.node.start.date), accountSupplyPointStartDate);
    });
    if (contractForAsp) {
        // tariffs started before or on acquisition date
        var preAcquisitionTariffs = contractForAsp.node.tariffs
            .filter(function (t) {
            return !(0, date_fns_1.isAfter)(new Date(t.tariff_nextV1.activeFrom), accountSupplyPointStartDate);
        })
            .map(function (tariff) { return tariff.tariff_nextV1; });
        if (preAcquisitionTariffs.length > 0) {
            var latestTariff = preAcquisitionTariffs.reduce(function (latestTariff, tariffToCompare) {
                return (0, date_fns_1.isAfter)(tariffToCompare.activeFrom, latestTariff.activeFrom)
                    ? tariffToCompare
                    : latestTariff;
            });
            var timingCategories = latestTariff === null || latestTariff === void 0 ? void 0 : latestTariff.consumptionChargeRates.ratesByTimingCategory.map(function (rate) { return rate.timingCategory; });
            return timingCategories;
        }
    }
    return [];
};
exports.getTimingCategoriesFromContracts = getTimingCategoriesFromContracts;
var dummyMetersFromContracts = function (contractsTariffData, sprn, accountSupplyPointStartDate) {
    var timingCategories = (0, exports.getTimingCategoriesFromContracts)(contractsTariffData, sprn, accountSupplyPointStartDate);
    return __assign(__assign({}, dummyOpeningMeterInfo), { registers: timingCategories.map(function (tc, index) { return (__assign(__assign({}, dummyOpeningRegister), { registerId: String(index), timeOfUseLabel: (0, utils_1.timingCategoryToTimeOfUseLabel)(tc) })); }) });
};
exports.dummyMetersFromContracts = dummyMetersFromContracts;
